import { render, staticRenderFns } from "./BaseTooltip.vue?vue&type=template&id=9ecd8e1c&"
import script from "./BaseTooltip.vue?vue&type=script&lang=js&"
export * from "./BaseTooltip.vue?vue&type=script&lang=js&"
import style0 from "floating-vue/dist/style.css?vue&type=style&index=0&lang=css&"
import style1 from "./BaseTooltip.vue?vue&type=style&index=1&id=9ecd8e1c&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/www/vhosts/dostartu.pl/app.startzone.online/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('9ecd8e1c')) {
      api.createRecord('9ecd8e1c', component.options)
    } else {
      api.reload('9ecd8e1c', component.options)
    }
    module.hot.accept("./BaseTooltip.vue?vue&type=template&id=9ecd8e1c&", function () {
      api.rerender('9ecd8e1c', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/BaseTooltip.vue"
export default component.exports